export default "__VITE_ASSET__69aeb86c__"